import { ErrorBoundary } from "components/Error/ErrorBoundary";
import { useGlobalModal } from "components/GlobalModal/useGlobalModal";
import { Box } from "prism-react";
import { Suspense, lazy } from "react";

const EmbedModal = lazy(() =>
  import("./EmbedModal").then((m) => ({
    default: m.EmbedModal,
  })),
);

// Main entry point
export const useEmbedModal = ({ editorURL }: { editorURL: URL }) => {
  const { close, open } = useGlobalModal(
    () => (
      <ErrorBoundary context="EMBED_MODAL">
        <Suspense
          fallback={
            // Matches the height of the final modal on `useEmbedModal`
            <Box css={{ height: `520px`, maxHeight: `calc(85vh - $6 * 2)` }} />
          }
        >
          <EmbedModal close={close} editorURL={editorURL} />
        </Suspense>
      </ErrorBoundary>
    ),
    {
      maxWidth: 950,
      closeOnInteractOutside: true,
    },
  );

  return { open, close };
};
